/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {FabNavItem} from '@fabric/components/common';
import {VIEW_AUTHORITY} from '../../common/constants';

/**
 * Created by michael faith on 11/22/2019.
 */
export const manageGFSVehiclesNavItem: FabNavItem = {
  name: 'GFS Vehicles',
  route: 'admin/manage-gfs-vehicles',
  authority: VIEW_AUTHORITY.centralOfficeAdminAuthority,
  subItems: [
    {
      name: 'Propulsion Segments',
      route: 'admin/manage-gfs-vehicles/segment-report',
      authority: VIEW_AUTHORITY.centralOfficeAdminAuthority
    },
    {
      name: 'Sales Lags',
      route: 'admin/manage-gfs-vehicles/manage-sales-lag',
      authority: VIEW_AUTHORITY.centralOfficeAdminAuthority
    },
    {
      name: 'Remove Obsolete Records',
      route: 'admin/manage-gfs-vehicles/remove-obsolete-records',
      authority: VIEW_AUTHORITY.systemAdminAuthority
    }
  ]
};
export const manageLoadPortfolioNavItem: FabNavItem = {
  name: 'Load New Portfolio',
  route: 'admin/load-new-portfolio',
  authority: VIEW_AUTHORITY.centralOfficeAdminAuthority,
  subItems: [
    {
      name: 'Vehicle',
      route: 'admin/load-new-portfolio/vehicle-portfolio',
      authority: VIEW_AUTHORITY.centralOfficeAdminAuthority,
      subItems: [
        {
          name: 'Load Portfolio',
          route: 'admin/load-new-portfolio/vehicle-portfolio/load-vehicle-portfolio',
          authority: VIEW_AUTHORITY.centralOfficeAdminAuthority
        },
        {
          name: 'Process GM3PD Snapshot',
          route: 'admin/load-new-portfolio/vehicle-portfolio/process-vehicle-snapshot',
          authority: VIEW_AUTHORITY.systemAdminAuthority
        },
        {
          name: 'Portfolio Transfer',
          route: 'admin/load-new-portfolio/vehicle-portfolio/portfolio-transfer',
          authority: VIEW_AUTHORITY.systemAdminAuthority
        },
        {
          name: 'Portfolio Archive',
          route: 'admin/load-new-portfolio/vehicle-portfolio/portfolio-archive',
          authority: VIEW_AUTHORITY.systemAdminAuthority
        },
      ]
    },
    {
      name: 'Propulsion',
      route: 'admin/load-new-portfolio/propulsion-portfolio',
      authority: VIEW_AUTHORITY.centralOfficeAdminAuthority,
      subItems: [
        {
          name: 'Load Portfolio',
          route: 'admin/load-new-portfolio/propulsion-portfolio/load-propulsion-portfolio',
          authority: VIEW_AUTHORITY.centralOfficeAdminAuthority
        },
        {
          name: 'Process GM3PD Snapshot',
          route: 'admin/load-new-portfolio/propulsion-portfolio/process-propulsion-snapshot',
          authority: VIEW_AUTHORITY.systemAdminAuthority
        }
      ]
    }
  ]
};

export const manageAttributesNavItem: FabNavItem = {
  name: 'Attributes',
  route: 'admin/manage-attributes',
  authority: VIEW_AUTHORITY.systemAdminAuthority,
  subItems: [
    {
      name: 'Vehicle Attributes',
      route: 'admin/manage-attributes/vehicle-attributes',
      authority: VIEW_AUTHORITY.systemAdminAuthority
    },
    {
      name: 'Engine Attributes',
      route: 'admin/manage-attributes/engine-attributes',
      authority: VIEW_AUTHORITY.systemAdminAuthority
    },
    {
      name: 'Transmission Attributes',
      route: 'admin/manage-attributes/transmission-attributes',
      authority: VIEW_AUTHORITY.systemAdminAuthority
    }
  ]
};

export const checkScenariosForDupesNavItem: FabNavItem = {
  name: 'Check All Scenarios for Dups',
  route: 'admin/duplicate-check',
  authority: VIEW_AUTHORITY.systemAdminAuthority,
  subItems: [
    {
      name: 'Vehicle',
      route: 'admin/duplicate-check/vehicle',
      authority: VIEW_AUTHORITY.systemAdminAuthority
    },
    {
      name: 'Propulsion',
      route: 'admin/duplicate-check/propulsion',
      authority: VIEW_AUTHORITY.systemAdminAuthority
    }
  ]
};

export const appNavItems: FabNavItem[] = [
  {
    name: 'Scenarios',
    route: '',
    authority: VIEW_AUTHORITY.userAuthority,
    iconName: 'home'
  },
  {
    name: 'Manage',
    route: 'manage',
    authority: [VIEW_AUTHORITY.userAuthority],
    subItems: [
      {
        name: 'Brand Family',
        route: 'manage-brand-family',
        authority: [VIEW_AUTHORITY.userAuthority],
        iconName: 'toys'
      },
      {
        name: 'Mkt Area/Planning Mkt Map',
        route: 'admin/manage-market-area-grouping',
        authority: VIEW_AUTHORITY.userAuthority
      },
      {
        name: 'Global Bulk Update to Portfolio',
        route: 'bulk-update-to-portfolio',
        authority: VIEW_AUTHORITY.userAuthority
      },
      {
        name: 'Scenario Details',
        authority: VIEW_AUTHORITY.userAuthority,
        subItems: [
          {
            name: 'Vehicle',
            route: 'update/manage-scenario-details/vehicle-scenarios',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Industry',
            route: 'update/manage-scenario-details/industry-scenarios',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Propulsion',
            route: 'update/manage-scenario-details/propulsion-scenarios',
            authority: VIEW_AUTHORITY.userAuthority
          }
        ]
      },
    ].sort((a, b) => a.name.localeCompare(b.name))
  },
  {
    name: 'Report',
    authority: [VIEW_AUTHORITY.userAuthority],
    subItems: [
      {
        name: 'Vehicle',
        authority: VIEW_AUTHORITY.userAuthority,
        subItems: [
          {
            name: 'GM Market Share of Segment',
            route: 'report/market-share-sgmnt-rpt',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Global Scenario Associations',
            route: 'report/global-scenario-associations',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Global Forecast Template',
            route: 'report/global-vehicle-forecast-template',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Global Consolidation',
            route: 'report/veh-consolidation-report',
            authority: VIEW_AUTHORITY.userAuthority,
          },
          {
            name: 'Audit - Global Segment Share',
            route: 'report/global-seg-shr-audit-rpt',
            authority: VIEW_AUTHORITY.userAuthority,
          },
          {
            name: 'Audit - Run Rates and Dates',
            route: 'report/run-rates-dates-report',
            authority: VIEW_AUTHORITY.userAuthority,
          },
          {
            name: 'Vehicle Volume Analysis',
            route: 'report/veh-vol-analysis-rpt',
            authority: VIEW_AUTHORITY.userAuthority,
          },
          {
            name: 'Variance by Mkt Div and Seg',
            route: 'report/variance-mkt-div-sgmnt-rpt',
            authority: VIEW_AUTHORITY.userAuthority
          }
        ].sort((a, b) => a.name.localeCompare(b.name)),
      },
      {
        name: 'Industry',
        authority: VIEW_AUTHORITY.userAuthority,
        subItems: [
          {
            name: 'Global Consolidation',
            route: 'report/industry-consolidation-report',
            authority: VIEW_AUTHORITY.userAuthority
          }
        ].sort((a, b) => a.name.localeCompare(b.name)),
      },
      {
        name: 'Propulsion',
        authority: VIEW_AUTHORITY.userAuthority,
        subItems: [
          {
            name: 'Global Forecast Template',
            route: 'report/global-propulsion-forecast-template',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Global Consolidation',
            route: 'report/propulsion-consolidation-report',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Audit - Veh/Prop Volumes',
            route: 'report/veh-prop-vol-compare',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Compare Scenario Volumes',
            route: 'report/compare-prop-vol-rpt',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Program Code by Fuel Type Share of Prop Seg',
            route: 'report/prgm-code-by-fuel-type-share-rpt',
            authority: VIEW_AUTHORITY.userAuthority
          }
        ].sort((a, b) => a.name.localeCompare(b.name)),
      },
      {
        name: 'Portfolio',
        authority: VIEW_AUTHORITY.userAuthority,
        route: 'report/portfolio'
      },
      {
        name: 'Pivot Table Data',
        authority: VIEW_AUTHORITY.userAuthority,
        subItems: [
          {
            name: 'Vehicle',
            route: 'vehicle/pivot-table-data',
            authority: VIEW_AUTHORITY.userAuthority
          },
          {
            name: 'Propulsion',
            route: 'propulsion/pivot-table-data',
            authority: VIEW_AUTHORITY.userAuthority
          }
        ]
      },
    ]
  },
  {
    name: 'Create',
    authority: [VIEW_AUTHORITY.userAuthority],
    subItems: [
      {
        name: 'Vehicle Scenario',
        route: 'vehicle/create-scenario',
        authority: VIEW_AUTHORITY.userAuthority
      },
      {
        name: 'Industry Scenario',
        route: 'industry/create-scenario',
        authority: VIEW_AUTHORITY.userAuthority
      }, {
        name: 'Propulsion Scenario',
        route: 'propulsion/create-scenario',
        authority: VIEW_AUTHORITY.userAuthority
      }
    ]
  },
  {
    name: 'Save Forecast',
    authority: [VIEW_AUTHORITY.userAuthority],
    subItems: [
      {
        name: 'Vehicle',
        route: 'vehicle/forecast-template/save',
        authority: VIEW_AUTHORITY.userAuthority
      },
      {
        name: 'Industry',
        route: 'industry/forecast-template/save',
        authority: VIEW_AUTHORITY.userAuthority
      },
      {
        name: 'Propulsion',
        route: 'propulsion/forecast-template/save',
        authority: VIEW_AUTHORITY.userAuthority
      },
      {
        name: 'Global Vehicle',
        route: 'vehicle/global-forecast-template/import',
        authority: VIEW_AUTHORITY.centralOfficeAdminAuthority
      },
      {
        name: 'Global Propulsion',
        route: 'propulsion/global-forecast-template/import',
        authority: VIEW_AUTHORITY.centralOfficeAdminAuthority
      }
    ]
  },
  {
    name: 'Admin',
    iconName: 'settings',
    route: 'admin',
    authority: VIEW_AUTHORITY.regionalAdminAuthority,
    subItems: [
      {
        name: 'Manage',
        route: '',
        authority: VIEW_AUTHORITY.regionalAdminAuthority,
        subItems: [
          {
            name: 'Segment Scheme',
            route: 'admin/segment-scheme-editor',
            authority: VIEW_AUTHORITY.systemAdminAuthority,
            iconName: 'toys'
          },
          {
            name: 'Scenario Cat / Fcst Gate',
            route: 'admin/manage-scenario-category-list',
            authority: VIEW_AUTHORITY.systemAdminAuthority,
            iconName: 'toys'
          },
          {
            name: 'Scenario Type List',
            route: 'admin/manage-scenario-type-list',
            authority: VIEW_AUTHORITY.systemAdminAuthority,
            iconName: 'toys'
          },
          {
            name: 'Propulsion Types',
            route: 'admin/manage-propulsion-types',
            authority: VIEW_AUTHORITY.systemAdminAuthority,
            iconName: 'toys'
          },
          {
            name: 'Forecast State',
            route: 'admin/manage-forecast-state',
            authority: VIEW_AUTHORITY.systemAdminAuthority,
            iconName: 'toys'
          },
          {
            name: 'Marketing Divisions',
            route: 'admin/manage-marketing-divisions',
            authority: VIEW_AUTHORITY.systemAdminAuthority
          },
          {
            name: 'Planning Markets',
            route: 'admin/manage-planning-market',
            authority: VIEW_AUTHORITY.systemAdminAuthority
          },
          {
            name: 'Subregions',
            route: 'admin/manage-subregions',
            authority: VIEW_AUTHORITY.systemAdminAuthority
          },
          {
            name: 'Architecture Deviances',
            route: 'admin/manage-arch-deviances',
            authority: VIEW_AUTHORITY.centralOfficeAdminAuthority
          },
          {
            name: 'Global Scenarios',
            route: 'admin/manage-global-scenarios',
            authority: VIEW_AUTHORITY.regionalAdminAuthority
          },
          {
            name: 'Scenarios',
            route: 'admin/manage-scenarios',
            authority: VIEW_AUTHORITY.systemAdminAuthority
          },
          manageGFSVehiclesNavItem,
          manageAttributesNavItem,
          {
            name: 'Users',
            route: 'admin/user-maintenance',
            authority: VIEW_AUTHORITY.systemAdminAuthority,
            iconName: 'toys'
          },
          {
            name: 'Eng/Tran Detail Report',
            authority: VIEW_AUTHORITY.systemAdminAuthority,
            route: 'admin/eng-tran-dtl-report'
          }
        ].sort((a, b) => a.name.localeCompare(b.name))
      },
      manageLoadPortfolioNavItem,
      checkScenariosForDupesNavItem
    ]
  }
];
